import {useEffect, useState} from "react";
import {agent} from "../../../api/agent";
import LoadingContainer from "../../LoadingContainer";
import styled from "styled-components";
import SearchInput from "../../Search/SearchInput";
import RepoPermissions from "../repo/RepoPermissions";
import DeploymentPermissions from "./DeploymentPermissions";

interface Props {
    permissions: string[];
    onChange: (permissions: string[]) => void;
}

const Deployment = styled.div`

    cursor: pointer;
    padding: .5rem 1.5rem;
    
    &:hover {
        background-color: var(--content-box-hover);
    }
    
    h2 {
        margin: 0;
        font-size: 1.2rem;
    }
`;

const Back = styled.div`
    cursor: pointer;
    padding: .5rem .5rem;

    &:hover {
        background-color: var(--content-box-hover);
    }
    
    span {
        margin-left: .5rem;
        font-size: 1.2rem;
    }
    
`;

interface Deployment {
    id: string;
    name: string;
    amount: number;
}

export default function DeploymentList(props: Props) {

    const [deployments, setDeployments] = useState<Deployment[]>([]);
    const [filteredDeployments, setFilteredDeployments] = useState<Deployment[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [selectedDeployment, setSelectedDeployment] = useState<string | null>(null);

    const load = () => {
        setLoading(true);
        agent.getDeployments().then(repos => {
            setLoading(false);
            setDeployments(repos.map(repo => {
                return {
                    id: repo.deploymentId,
                    name: repo.deploymentName,
                    amount: props.permissions.filter(value => value.startsWith("deployment."+repo.deploymentId+".")).length
                }
            }).sort((a, b) => b.amount - a.amount));
        });
    }

    useEffect(() => {
        load();
    }, []);

    return (
        <LoadingContainer open={loading}>
            {!selectedDeployment && (<>
                <SearchInput data={deployments} setSearchResult={setFilteredDeployments} searchableKeys={['name']}></SearchInput>
                {filteredDeployments.map(deployment => (
                    <Deployment key={deployment.id} style={{cursor: 'pointer'}} onClick={() => {
                        setSelectedDeployment(deployment.id);
                    }}>
                        <h2 style={{display: 'inline-block'}}>{deployment.name}</h2>
                        <span style={{float: 'right'}}>{deployment.amount} Permissions set</span>
                    </Deployment>
                ))}
            </>)}
            {selectedDeployment && (
                <div>
                    <Back style={{cursor: 'pointer'}} onClick={() => {
                        load();
                        setSelectedDeployment(null);
                    }}>
                        <i className="fa-solid fa-angle-left"></i>
                        <span>Selected Repo: {deployments.find(value => value.id === selectedDeployment)?.name}</span>
                    </Back>

                    <DeploymentPermissions permissions={props.permissions} onChange={props.onChange} deployment={selectedDeployment}></DeploymentPermissions>
                </div>
            )}

        </LoadingContainer>
    )



}

